module.exports = __webpack_public_path__ + "img/invest5.3e6e9fc2.jpeg";